<template lang="pug">

</template>

<script>

  export default {

    name: 'cbs-exam',

    data: function() {
      
      return {
        location: '',
        date: '',
        firstDeadline: '',
        secondDeadline: '',
      };
    }

  };

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// exam.vue?64397a28